<template>
  <div class="user-wrapper">
    <div class="content-box">
      <!-- <a href="https://gitee.com/kaiyuantuandui/prex" target="_blank">
        <span class="action">
          <a-icon type="question-circle-o"></a-icon> 
        </span>
      </a>
      <notice-icon class="action"/>-->
      <a-dropdown>
        <span class="action ant-dropdown-link user-dropdown-menu">
          <!-- <a-avatar class="avatar" size="small" :src="avatar"/> -->
          <span>{{ nickname }}</span>
        </span>
        <a-menu slot="overlay" class="user-dropdown-menu-wrapper">
          <a-menu-item key="0">
            <router-link :to="{ name: 'settings' }">
              <a-icon type="user"/>
              <span>个人中心</span>
            </router-link>
          </a-menu-item>
          <a-menu-item key="1"  @click="systemSetting">
            <a-icon type="tool"/>
            <span>系统设置</span>
          </a-menu-item>
          <a-menu-divider/>
          <a-menu-item key="2">
            <a href="javascript:;" @click="handleLogout">
              <a-icon type="logout"/>
              <span>退出登录</span>
            </a>
          </a-menu-item>
        </a-menu>
      </a-dropdown>
      <!-- <lang-select /> -->
    <!--系统设置-->
    </div>
    <setting-drawer ref="settingDrawer" :closable="true" title="系统设置"></setting-drawer>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import SettingDrawer from "@/components/SettingDrawer";

export default {
  name: 'UserMenu',
  components: {
    SettingDrawer
  },
  computed: {
    ...mapGetters(['nickname', 'avatar'])

  },
  methods: {
    ...mapActions(['Logout']),
    handleLogout () {
      this.$confirm({
        title: '提示',
        content: '真的要注销登录吗 ?',
        onOk: () => {
          return this.Logout({}).then(() => {
            setTimeout(() => {
              // window.location.reload()
              window.location.href = "/user/login"
            }, 16)
          }).catch(err => {
            this.$message.error({
              title: '错误',
              description: err.message
            })
          })
        },
        onCancel () {
        }
      })
    },
    systemSetting(){
      this.$refs.settingDrawer.showDrawer()
    }
  }
}
</script>
